var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    max-width: 100%;\n  }\n  text {\n    font-family: ", ";\n    fill: ", ";\n    tspan {\n      font-family: ", ";\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components'), require('@rtm-ui/theme'), require('handlebars'), require('axios')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components', '@rtm-ui/theme', 'handlebars', 'axios'], factory) : (global = global || self, factory(global['dynamic-svg'] = {}, global.React, global.styled, global.RtmUiTheme, global.Handlebars, global.Axios));
})(this, function (exports, React, styled, theme, Handlebars, axios) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;
  Handlebars = Handlebars && Object.prototype.hasOwnProperty.call(Handlebars, 'default') ? Handlebars['default'] : Handlebars;
  axios = axios && Object.prototype.hasOwnProperty.call(axios, 'default') ? axios['default'] : axios;
  var Wrapper = styled.div(_templateObject(), function (p) {
    return p.theme.fonts.sansSerif;
  }, function (p) {
    return theme.getColor('primary', p.theme);
  }, function (p) {
    return p.theme.fonts.sansSerif;
  }, function (p) {
    return theme.getColor('primary', p.theme);
  });

  var DynamicSvg = function DynamicSvg(_ref) {
    var src = _ref.src,
        referenceObject = _ref.referenceObject;

    var _React$useState = React.useState(''),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        svgString = _React$useState2[0],
        setSvgString = _React$useState2[1];

    React.useEffect(function () {
      if (svgString) {
        var template = Handlebars.compile(svgString);
        var interpolatedSvgString = template(referenceObject);
        setSvgString(interpolatedSvgString);
      }
    }, [referenceObject, svgString]);
    React.useEffect(function () {
      var getSvg =
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return axios.get(src);

                case 3:
                  response = _context.sent;
                  setSvgString(response.data);
                  _context.next = 10;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  console.error(_context.t0);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        return function getSvg() {
          return _ref2.apply(this, arguments);
        };
      }();

      getSvg();
    }, [src]);

    var createMarkup = function createMarkup() {
      return {
        __html: svgString
      };
    };

    return (
      /*#__PURE__*/
      React.createElement(Wrapper, {
        dangerouslySetInnerHTML: createMarkup()
      })
    );
  };

  exports.DynamicSvg = DynamicSvg;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});